module.exports = __webpack_public_path__ + "MuseoSans-500.31861b80ebeff0d0eba6.svg";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-500.svg
// module id = ../../../../../src/assets/fonts/MuseoSans-500.svg
// module chunks = styles